import { Dialog as MuiDialog, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Dialog = styled(MuiDialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    minHeight: "450px",
    minWidth: "450px",
    borderRadius: "4px",
    boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
    padding: theme.spacing(2, 2.5),
  },

  "& .MuiDialogContent-root, .MuiDialogTitle-root": {
    padding: 0,
  },
}));

export const CloseButton = styled(IconButton)({
  position: "absolute",
  top: "10px",
  right: "10px",
});
